import EmptyStatesPreview from '../content/EmptyStatesPreview'
import { AccessControl } from '@eggplant/context'
import { HiPlus } from 'react-icons/hi'
import { LinkButton } from '@eggplant/pattern-library'
import { LinkToAddMonitorConfig } from '@eggplant/routing'
import { LinkToMonitorConfigDoc } from '../links'
import { PageIcon } from '@eggplant/pattern-library/src/lib/components/Artwork/Artwork'

const description = `Monitor configs are test cases tests grouped in specific sequences to run against systems under test (SUTs) regularly, which will provide a series of test results against time that you can check in monitor results and dashboard page.

📝 Start adding your monitor configurations now!`

const renderButton = () =>
  <AccessControl isHiddenIfDenied>
    <LinkButton variant='primary'>
      <LinkToAddMonitorConfig>
        <HiPlus
          aria-hidden
          size='19px'
        /> New Monitor Config
      </LinkToAddMonitorConfig>
    </LinkButton>
  </AccessControl>

const MonitorConfigIntro = () =>
  <div className='grid h-full justify-center'>
    <div className='grid w-[36em]'>
      <EmptyStatesPreview
        action={renderButton()}
        description={description}
        icon={<PageIcon />}
        renderLink={<LinkToMonitorConfigDoc />}
        title='Monitor Configuration'
      />
    </div>
  </div>

export default MonitorConfigIntro
